import { apiSlice } from "app/api/apiSlice"

export const attendanceApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['AttendanceEvent', 'AttendancePresence'],
    endpoints: builder => ({

        getAttendancePresence: builder.query({
            query: () => ({ url: 'attendance/presence' }),
            providesTags: ['AttendancePresence']
        }),

        getRecentBadgeEvents: builder.query({
            query: (limit = 20) => ({
                url: 'attendance/events/recent',
                params: { limit }
            }),
            providesTags: ['AttendanceEvent']
        }),

        getBadgeEventsPaged: builder.query({
            query: ({ page = 0, size = 20, fromEpoch, toEpoch, businessUnitGuid }) => ({
                url: 'attendance/events',
                params: {
                    page,
                    size,
                    ...(fromEpoch != null && { fromEpoch }),
                    ...(toEpoch != null && { toEpoch }),
                    ...(businessUnitGuid != null && { businessUnitGuid })
                }
            }),
            providesTags: ['AttendanceEvent']
        })
    })
})

export const {
    useGetAttendancePresenceQuery,
    useGetRecentBadgeEventsQuery,
    useGetBadgeEventsPagedQuery
} = attendanceApiSlice
